import script from "./home.vue?vue&type=script&setup=true&lang=js"
export * from "./home.vue?vue&type=script&setup=true&lang=js"

import "./home.vue?vue&type=style&index=0&id=27b8742f&lang=less&scoped=true"

import exportComponent from "E:\\zhengbo-supplychain\\web-supplychain\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-27b8742f"]])

export default __exports__